<ng-container *ngIf="!isLoading; then main; else loader"></ng-container>

<ng-template #loader>
  <app-loader [loading]="isLoading" [size]="64"></app-loader>
</ng-template>

<ng-template #main>
  <div [ngClass]="{'desktop': createFormVisible}">
    <app-dialog-header [title]="invoice.invoiceNumber ? 'general.api_invoice_no' : 'general.api_generate_invoice_modal_title'"
                       [suffix]="invoice.invoiceNumber" [withConfirm]="true" (closed)="confirmClose()"></app-dialog-header>
    <div class="left-spacer-x2 right-spacer-x2 mobile">
      <mat-button-toggle-group class="content-switcher max-width" [(ngModel)]="showDetails">
        <mat-button-toggle [value]="true">{{'general.api_invoice_details' | translate}}</mat-button-toggle>
        <mat-button-toggle [value]="false">{{'general.api_invoice_tickets' | translate}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <!-- INFO SECTION -->
    <div class="dialog-info" [ngClass]="{'desktop': !showDetails}">
      <div class="flex flex-column-mobile">
        <div class="label-value bottom-spacer">
          <span class="label">{{'general.api_transactions_table_time' | translate}}:</span>
          {{transaction.date | moment : {format: viewService.conf.dateTimeFormatWithSeconds, local: false} }}
        </div>
        <div class="label-value bottom-spacer">
          <span class="label">{{'general.api_transactions_table_buyer' | translate}}:</span>
          <ng-container *ngIf="transaction.customer">
            {{transaction.customer.firstName}} {{transaction.customer.lastName}}
          </ng-container>
          <ng-container *ngIf="!transaction.customer">
            -
          </ng-container>
        </div>
        <div class="label-value bottom-spacer" *ngIf="invoice.invoiceNumber">
          <span class="label">{{'general.api_invoice_no' | translate}}:</span>
          <span class="text-secondary pointer" (click)="invoiceService.downloadInvoice(invoice)"><b>&nbsp;{{invoice.invoiceNumber}}</b></span>
        </div>
      </div>
      <div class="flex flex-column-mobile">
        <div class="label-value bottom-spacer">
          <span class="label">{{'general.api_transactions_table_seller' | translate}}:</span>
          <ng-container *ngIf="transaction.seller">
            {{transaction.seller.firstName}} {{transaction.seller.lastName}}
          </ng-container>
          <ng-container *ngIf="!transaction.seller">
            -
          </ng-container>
        </div>
        <div class="label-value bottom-spacer">
          <span class="label">{{'general.api_reports_salespoint' | translate}}:</span>
          {{transaction.salespoint?.name || '-'}}
        </div>
        <div class="label-value bottom-spacer" *ngIf="invoice.created">
          <span class="label">{{'general.api_invoice_date' | translate}}:</span>
          {{invoice.created | moment: { format: viewService.conf.dateTimeFormatWithSeconds, local: false, includeOffset: true } }}
        </div>
      </div>
    </div>
    <mat-dialog-content>
      <div [ngClass]="{'desktop': !showDetails}">
        <!-- INVOICE TYPE -->
        <app-label-value [label]="'general.api_invoice_type'" [template]="invoiceTypeTemplate" [required]="true" [withMargin]="true"></app-label-value>
        <ng-template #invoiceTypeTemplate>
          <mat-radio-group class="flex" [disabled]="isReadOnly" [(ngModel)]="privateInvoice" (change)="clearPreviousFields()">
            <mat-radio-button [value]="true">{{'general.api_invoice_type_private' | translate}}</mat-radio-button>
            <mat-radio-button [value]="false">{{'general.api_invoice_type_legal' | translate}}</mat-radio-button>
          </mat-radio-group>
        </ng-template>
        <hr>
        <!-- INVOICE INFO -->
        <app-label-value [label]="'general.api_invoice_info'" [template]="invoiceInfoTemplate" [required]="true" [withMargin]="true"></app-label-value>
        <ng-template #invoiceInfoTemplate>
          <div class="flex flex-grow flex-column-mobile">
            <div class="flex flex-flat">
              <!-- CUSTOMER -->
              <app-scroll-load label="general.api_reservation_table_customer" *ngIf="privateInvoice"
                               [maxWidth]="true" [minInput]="3"
                               [searchService]="customerService" [scrollLoad]="customerScrollLoad"
                               [withSuffix]="!isReadOnly" [disabled]="!this.canGet || createFormVisible || isReadOnly" (clearEvent)="clearCustomer(); closeCreateForm()"
                               [(selectedObjectId)]="invoiceData.customerUuid"></app-scroll-load>
              <!-- LEGAL PERSON -->
              <app-scroll-load label="general.api_reservation_form_legal_person" *ngIf="!privateInvoice"
                               [maxWidth]="true" [minInput]="3"
                               [displayOption]="legalPersonService.displayScrollLoadOptionNameAndRegCode"
                               [displaySelection]="legalPersonService.displayScrollLoadSelectionNameAndRegCode"
                               [customQuery]="legalPersonService.setPageableQuery"
                               [searchService]="legalPersonService" [scrollLoad]="legalPersonScrollLoad"
                               [withSuffix]="!isReadOnly" [disabled]="!this.canGet || createFormVisible || isReadOnly" (clearEvent)="clearLegalPerson(); closeCreateForm()"
                               [required]="true"
                               [(selectedObjectId)]="invoiceData.legalPersonId"></app-scroll-load>
              <button mat-button class="icon-button input-button suffix-button desktop" *ngIf="!isReadOnly"
                      [disabled]="createFormVisible || !this.canCreate" (click)="openCreateForm()">
                <mat-icon class="svg-icon" [svgIcon]="privateInvoice ? 'add_user' : 'add_legal_person'"></mat-icon>
              </button>
              <button mat-button class="icon-button input-button suffix-button mobile" [matMenuTriggerFor]="createEditPersonMenu" *ngIf="!isReadOnly" [disabled]="createFormVisible">
                <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
              </button>
              <mat-menu #createEditPersonMenu="matMenu">
                <button mat-menu-item *ngIf="this.canCreate" (click)="openCreateForm()">
                  {{'general.api_invoice_create_person' | translate}}
                </button>
                <button mat-menu-item (click)="openEditForm()" [disabled]="!invoiceData.customerUuid && !invoiceData.legalPersonId">
                  {{'general.api_invoice_edit_person' | translate}}
                </button>
              </mat-menu>
            </div>
            <!-- DUE DATE -->
            <app-datepicker [dateStart]="currentDate" [(dateEnd)]="invoiceData.dueDate" [disabled]="isReadOnly"
                            [valid]="hideInvalidDueDateHint" [datePickerConfig]="{label: 'general.api_invoice_due_date', range: true, autoBindDates: true, lockStart: true}"></app-datepicker>
          </div>
        </ng-template>
        <div class="desktop">
          <div class="dialog-inner-component" *ngIf="privateInvoice && (createFormVisible || invoiceData.customerUuid)">
            <app-customer-view *ngIf="!invoiceData.customerUuid" (cancelChange)="clearCustomer(); closeCreateForm()" (confirmChange)="selectCustomer($event)"
                               [readonly]="isBuyerDataReadOnly" [isInternalComponent]="true"></app-customer-view>
            <app-customer-view *ngIf="invoiceData.customerUuid" (cancelChange)="clearCustomer(); closeCreateForm()" (confirmChange)="selectCustomer($event)"
                               [readonly]="isBuyerDataReadOnly" [customerUuid]="invoiceData.customerUuid" [isInternalComponent]="true"></app-customer-view>
          </div>
          <div class="dialog-inner-component" *ngIf="!privateInvoice && (createFormVisible || invoiceData.legalPersonId)">
            <app-legal-person-view *ngIf="!invoiceData.legalPersonId" (cancelChange)="clearLegalPerson(); closeCreateForm()" (confirmChange)="selectLegalPerson($event)"
                                   [readonly]="isBuyerDataReadOnly" [isInternalComponent]="true"></app-legal-person-view>
            <app-legal-person-view *ngIf="invoiceData.legalPersonId" (cancelChange)="clearLegalPerson(); closeCreateForm()" (confirmChange)="selectLegalPerson($event)"
                                   [readonly]="isBuyerDataReadOnly" [legalPersonId]="invoiceData.legalPersonId" [isInternalComponent]="true"></app-legal-person-view>
          </div>
        </div>
        <hr>
        <app-label-value [label]="'general.api_invoice_description'" [template]="invoiceDescriptionTemplate" [withMargin]="true"></app-label-value>
        <ng-template #invoiceDescriptionTemplate>
          <div class="flex flex-grow flex-column-mobile">
            <!-- DESCRIPTION -->
            <app-text-input class="max-width" [type]="TextInputType.Textarea" [label]="'general.api_invoice_remarks'"
                            [(value)]="invoiceData.description" [disabled]="isReadOnly"></app-text-input>
            <!-- INTERNAL COMMENTS -->
            <app-text-input class="max-width"  [type]="TextInputType.Textarea" [label]="'general.api_invoice_internal_comments'"
                            [(value)]="invoiceData.comment" [disabled]="isReadOnly"></app-text-input>
          </div>
        </ng-template>
        <hr class="desktop">
        <br class="mobile">
      </div>
      <!-- TICKETS -->
      <div class="desktop" *ngIf="!utilService.isMobile">
        <app-label-value [label]="'general.api_general_tickets'" [template]="invoiceTicketsTemplate" [withMargin]="true"></app-label-value>
        <ng-template #invoiceTicketsTemplate>
          <ng-container *ngIf="transaction?.cart.events.length && isReady">
            <app-data-table [(config)]="tableConfig" [(data)]="transaction.cart.events"></app-data-table>
          </ng-container>
        </ng-template>
      </div>
      <div class="mobile" [ngClass]="{'desktop': showDetails}" *ngIf="utilService.isMobile">
        <table class="ticket-table report-table">
          <tbody>
          <ng-container *ngFor="let event of transaction.cart.events">
            <tr *ngFor="let ticket of (isLegacy ? event.legacyTickets : event.tickets)">
              <td>
                <h3 class="title">{{ 'general.api_cart_table_ticket_id' | translate }}: {{ ticket.id }}</h3>
                <table class="ticket-inner-table">
                  <tbody>
                  <tr>
                    <td class="label">{{ 'general.api_cart_table_title' | translate }}</td>
                    <td class="value">
                      <span class="title">{{ event.title | translateValue }}</span>
                      <br>{{ event.venueTitle }}
                      <ng-container *ngIf="!event.isSeason"><br>{{ event.eventDate | period: {hasTimeInPeriod: true} }}</ng-container>
                    </td>
                  </tr>
                  <tr *ngIf="isLegacy">
                    <td class="label">{{ 'general.api_cart_table_sector' | translate }}</td>
                    <td class="value">
                      <span>{{ (ticket.sectorName | translate) !== ticket.sectorName ? (ticket.sectorName | translate) : ticket.sectorId }}</span>
                      <span *ngIf="ticket.row">, {{ 'general.api_cart_table_row' | translate }} {{ ticket.row }}</span>
                      <span *ngIf="ticket.place">, {{ 'general.api_cart_table_seat' | translate }} {{ ticket.place }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="label">{{ 'general.api_cart_table_price' | translate }}</td>
                    <td class="value">
                      <span>{{ ticket | ticketPrice:true }}</span>
                      <ng-container *ngIf="ticket.insurance">
                        <br><span>{{ ticket.insurance.commissionFee | price }}</span>
                        <ng-container *ngIf="ticket.insurance.insuranceFee">&nbsp;/&nbsp;<span>{{ ticket.insurance.insuranceFee | price }}</span></ng-container>
                      </ng-container>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>
    </mat-dialog-content>
    <app-dialog-footer [dialogActions]="dialogActions"></app-dialog-footer>
    <ng-template #dialogActions>
      <button mat-button (click)="confirmClose()">{{ 'general.api_general_close' | translate }}</button>
      <button mat-flat-button color="primary" *ngIf="!isReadOnly" [disabled]="!isValid"
              (click)="createInvoice()">{{ 'general.api_invoice_create' | translate }}</button>
    </ng-template>
  </div>
  <div class="mobile">
    <div class="dialog-inner-component" *ngIf="privateInvoice && createFormVisible">
      <app-customer-view *ngIf="!invoiceData.customerUuid" (cancelChange)="clearCustomer(); closeCreateForm()" (confirmChange)="selectCustomer($event)"
                         [readonly]="isBuyerDataReadOnly" [isInternalComponent]="true"></app-customer-view>
      <app-customer-view *ngIf="invoiceData.customerUuid" (cancelChange)="closeCreateForm()" (confirmChange)="selectCustomer($event)"
                         [readonly]="isBuyerDataReadOnly" [customerUuid]="invoiceData.customerUuid" [isInternalComponent]="true"></app-customer-view>
    </div>
    <div class="dialog-inner-component" *ngIf="!privateInvoice && createFormVisible">
      <app-legal-person-view *ngIf="!invoiceData.legalPersonId" (cancelChange)="clearLegalPerson(); closeCreateForm()" (confirmChange)="selectLegalPerson($event)"
                             [readonly]="isBuyerDataReadOnly" [isInternalComponent]="true"></app-legal-person-view>
      <app-legal-person-view *ngIf="invoiceData.legalPersonId" (cancelChange)="closeCreateForm()" (confirmChange)="selectLegalPerson($event)"
                             [readonly]="isBuyerDataReadOnly" [legalPersonId]="invoiceData.legalPersonId" [isInternalComponent]="true"></app-legal-person-view>
    </div>
  </div>
</ng-template>


<ng-template #tableEvent let-item="item">
  <span class="title">{{ item.title | translateValue }}</span>
  <app-event-info-props [eventProps]="{venueTitle: item.venueTitle, onlineLocation: item.onlineLocation}"></app-event-info-props>
</ng-template>

<ng-template #tableDate let-item="item">
  <ng-container *ngIf="!item.isSeason">{{ item.eventDate | period: {hasTimeInPeriod: true} }}</ng-container>
</ng-template>

<ng-template #tableTicketType let-item="item">
  <span [ngClass]="{'title' : item.insurance}">
    <ng-container *ngIf="isLegacy">
      {{ item.priceTypeName | translate }}
    </ng-container>
    <ng-container *ngIf="!isLegacy">
      {{ item.ticketTypeName | translateValue }}
    </ng-container>
  </span>
  <ng-container *ngIf="item.insurance">
    <br>+&nbsp;<span>{{ 'general.api_cart_insurance_commission' | translate }}</span>
    <ng-container *ngIf="item.insurance.insuranceFee">&nbsp;/&nbsp;<span>{{ 'general.api_cart_insurance' | translate }}</span></ng-container>
  </ng-container>
</ng-template>

<ng-template #tableTicketPrice let-item="item">
  <span class="title white-space-no-wrap">{{ item | ticketPrice:true }}</span>
  <ng-container *ngIf="item.insurance">
    <br><span class="white-space-no-wrap">{{ item.insurance.commissionFee | price }}</span>
    <ng-container *ngIf="item.insurance.insuranceFee">&nbsp;/&nbsp;<span class="white-space-no-wrap">{{ item.insurance.insuranceFee | price }}</span></ng-container>
  </ng-container>
</ng-template>
